import { render, staticRenderFns } from "./OrdersInNominative.vue?vue&type=template&id=38dce1a7"
import script from "./OrdersInNominative.vue?vue&type=script&lang=js"
export * from "./OrdersInNominative.vue?vue&type=script&lang=js"
import style0 from "./OrdersInNominative.vue?vue&type=style&index=0&id=38dce1a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports